import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function dropdown({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="8"
      fill="black"
      viewBox="0 0 12 8"
      className={className}
    >
      <path
        stroke="none"
        fillRule="evenodd"
        d="M11.707.293a1 1 0 00-1.414 0L6 4.586 1.707.293A1 1 0 00.293 1.707L6 7.414l5.707-5.707a1 1 0 000-1.414z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default dropdown;
